import React from 'react';
import PropTypes from 'prop-types';
import { SHOW_ADD_ONS_KEY, useExperiment } from '../../experiments';
import { SlidingContainer } from '../SlidingContainer';
import { Icon } from '../../icons';
import { VisuallyHidden } from '../../atoms';
import { AddOnSummaryCards } from '../AddOnSummaryCards';
import { ProductsSummaryDisplay } from './ProductsSummaryDisplay';
import {
  Header,
  MobileHeader,
  Title,
  CloseIcon,
  BackLabel,
  ProductSummariesWrapper,
} from './styles';

export const ProductsSummarySlider = ({
  menuHeader,
  sections,
  onCloseMenu,
  onGoBack,
  active,
}) => {
  const { value: showAddOns } = useExperiment(SHOW_ADD_ONS_KEY, false);

  return (
    <SlidingContainer
      active={active}
      onExit={onCloseMenu}
      bgColor="background.base"
      alignment="left"
      maxWidth={556}
    >
      <ProductSummariesWrapper>
        <Header>
          <Title>{menuHeader}</Title>
          <CloseIcon aria-label="CloseIcon" onClick={onCloseMenu}>
            <Icon
              iconName="close"
              alt=""
              size={1.4}
              id="prod_summary_desk_close"
            />
            <VisuallyHidden>Close</VisuallyHidden>
          </CloseIcon>
        </Header>
        <MobileHeader>
          <BackLabel aria-label="CloseIcon" onClick={onGoBack}>
            <Icon
              iconName="arrow-left"
              alt=""
              size={1.4}
              id="prod_summary_mobile_close"
            />
            <VisuallyHidden>Close</VisuallyHidden>
            <Title>Back</Title>
          </BackLabel>
        </MobileHeader>
        {sections.map((section, index) => {
          if (section.component === 'add_on_summary_cards')
            return showAddOns ? (
              <AddOnSummaryCards
                {...section}
                key={index}
                onClick={onCloseMenu}
              />
            ) : null;
          return (
            //  have a default return so this one will be it for now since we can't use CMSBlok
            <ProductsSummaryDisplay
              {...section}
              key={index}
              onRecipeClick={onCloseMenu}
            />
          );
        })}
      </ProductSummariesWrapper>
    </SlidingContainer>
  );
};

ProductsSummarySlider.displayName = 'Products Summary Slider';

ProductsSummarySlider.propTypes = {
  menuHeader: PropTypes.string.isRequired,
  sections: PropTypes.array,
  onCloseMenu: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};
